import { TaskQueryRepresentation } from '@alfresco/js-api';

export enum EbenTaskQueryRepresentationKeys {
  "searchableVariables" = 'searchableVariables',
  "searchableVariablesQuery" = 'searchableVariablesQuery',
  "assignment" = 'assignment',
}

export interface EbenTaskQueryRepresentation extends TaskQueryRepresentation {
  includeProcessVariables?: boolean;
  includeTaskLocalVariables?: boolean;
  searchableVariablesQuery?: string;
  searchableVariables?: string[];
}

export const defaultEbenTaskQueryRepresentation: EbenTaskQueryRepresentation = {
  state: TaskQueryRepresentation.StateEnum.Active,
  sort: TaskQueryRepresentation.SortEnum.CreatedDesc,
  page: 0,
  size: 25
}
